import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";  
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";  
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";  
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";  
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";  
import useAdjustmentReasonCodeList from "./hooks/useAdjustmentReasonCodeList";  
  
const AdjustmentReasonCodeList = () => {  
  const adjustmentReasonCodeListData = useAdjustmentReasonCodeList();  
  
  return (  
    <div class="container container-fluid">  
     <ButtonsSection ctaButtons={adjustmentReasonCodeListData.leftButtons} align="left" />
      <div className="header-section">  
        <h1>  
          {adjustmentReasonCodeListData.screen_title} -{" "}  
          <span className="heading-cod">  
            {adjustmentReasonCodeListData.screenNumber}  
          </span>  
        </h1>  
      </div>  
      <SearchBox  
        formFields={adjustmentReasonCodeListData.formFields}  
        paramsData={adjustmentReasonCodeListData.paramsData}  
        updataParamData={adjustmentReasonCodeListData.updateParamData}  
      />  
      <ButtonsSection ctaButtons={adjustmentReasonCodeListData.ctaButtons} />  
      <DisplayTable 
        selectMode={adjustmentReasonCodeListData.selectMode} 
        data={adjustmentReasonCodeListData.data}  
        parmKey={adjustmentReasonCodeListData.parmKey}  
        menuOptions={adjustmentReasonCodeListData.menuOptions}  
        tableHeaders={adjustmentReasonCodeListData.columnDef}  
        setRowData={adjustmentReasonCodeListData.setRowData}  
        selectedPriceSchedules={adjustmentReasonCodeListData.selectedRows}  
        setSelectedPriceSchedules={adjustmentReasonCodeListData.setSelectedRows}  
      />  
      <div className="paginator-container">  
        <NextGenPaginator  
          first={adjustmentReasonCodeListData.first}  
          rows={adjustmentReasonCodeListData.rows}  
          totalRecords={adjustmentReasonCodeListData.totalRecords}  
          currentPage={adjustmentReasonCodeListData.currentPage}  
          rowsPerPageOptions={[10, 25, 50]}  
          onPageChange={adjustmentReasonCodeListData.onPageChange}  
        />  
      </div>  
      {adjustmentReasonCodeListData.isConfirmationModalOpen && (  
        <ConfirmationModal  
          isOpen={adjustmentReasonCodeListData.isConfirmationModalOpen}  
          onRequestClose={adjustmentReasonCodeListData.closeConfirmationModal}  
          onBack={adjustmentReasonCodeListData.closeConfirmationModal}  
          onSave={adjustmentReasonCodeListData.deleteAdjustmentReasonCodeList}  
          confirmLabel="Confirm(Y/N)"  
          options={[  
            { label: "N-No", value: "no" },  
            { label: "Y-Yes", value: "yes" },  
          ]}  
          setSelectedOption={adjustmentReasonCodeListData.setSelectedOption}  
        />  
      )}  
    </div>  
  );  
};  
  
export default AdjustmentReasonCodeList;